import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import env from '../../config';

const ExtraServiceCustomer = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [project, setProject] = useState({}); // estado para armazenar os dados do projeto
  const [executedPhotos, setExecutedPhotos] = useState([]); // estado para armazenar as fotos executadas
  const [referencePhotos, setReferencePhotos] = useState([]); // estado para armazenar as fotos executadas
  const location = useLocation();
  let stylesLoaded = false;
  const backendUrl = env.backendUrl;
  const url = backendUrl;
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const isTailwindRoute = location.pathname.startsWith('/extraService-customer');
    if (isTailwindRoute && !stylesLoaded) {
      import('../../tailwind.css')
        .then(() => {
          stylesLoaded = true;
        })
        .catch(error => {
          console.error('Erro ao carregar estilos do Timesheet:', error);
        });
    }
  }, [location]);

  useEffect(() => {
    // busca na API pelo id do projeto
    fetch(url + `/extra-services/${id}`)
      .then(response => response.json())
      .then(data => {
        setProject(data.data);
        // Verifica se executed_photos é uma string JSON e converte se necessário
        const executedPhotos = typeof data.data.executed_photos === 'string'
          ? JSON.parse(data.data.executed_photos)
          : [];
        setExecutedPhotos(executedPhotos);

        const referencePhotos = typeof data.data.reference_photos === 'string'
          ? JSON.parse(data.data.reference_photos)
          : [];
        setReferencePhotos(referencePhotos);
      })
      .catch(error => console.error('Erro ao buscar projeto:', error));
  }, [id]);

  return (
    <div className="max-w-md mx-auto p-4 space-y-4 bg-white min-h-screen">
      <h2 className="text-xl font-bold text-center">Service Details</h2>

      <div className="bg-white rounded-2xl shadow p-4 space-y-2">
        <div className="text-sm space-y-2">
          <div>
            <p className="text-gray-500 text-xs">Request Date</p>
            <p className="font-medium">{project.request_date}</p>
          </div>
          <div>
            <p className="text-gray-500 text-xs">Service Address</p>
            <p className="font-medium">{project.service_address}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm font-semibold mb-3">Reference Photos:</h3>
        <div className="flex flex-wrap gap-3">
          {referencePhotos && referencePhotos.map((src, index) => (
            <div key={index} className="relative w-20 h-20">
              <img src={src}  
                onClick={() => setSelectedImage(src)}
                referrerPolicy="no-referrer"
                alt={`Uploaded ${index + 1}`} className="w-full h-full object-cover rounded-lg" />
            </div>
          ))}
        </div>
      </div>

      {executedPhotos.length > 0 && (
        <div className="bg-white rounded-2xl shadow p-4">
          <h3 className="text-sm font-semibold mb-3">Service completed:</h3>
          <div className="flex flex-wrap gap-3">
            {executedPhotos && executedPhotos.map((src, index) => (
              <div key={index} className="relative w-20 h-20">
                <img src={src}  
                  onClick={() => setSelectedImage(src)}
                  referrerPolicy="no-referrer"
                  alt={`Uploaded ${index + 1}`} className="w-full h-full object-cover rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-4 -right-4 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow-lg hover:bg-gray-200"
              aria-label="Fechar"
            >
              ✕
            </button>

            <img
              src={selectedImage} 
              alt="Zoomed"
              referrerPolicy="no-referrer"
              className="max-w-[90vw] max-h-[90vh] rounded-lg border-4 border-white shadow-xl"
            />
            <label className='stamp'>....</label>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExtraServiceCustomer;
